'use client';

import { useParams } from 'next/navigation';

import { DEFAULT_LOCALE, isLangRTL, TLocale } from '@northladder/utilities';

type TUseRTLReturnType = {
  /**
   * The direction of the layout based on the active language.
   */
  dir: 'ltr' | 'rtl';
  /**
   * The direction boolean of the layout based on the active language.
   */
  isRTL: boolean;
  /**
   * The locale as fetched from the route path
   */
  locale: TLocale;
};

/**
 * This provides re-usable logic for the `locale` and language config.
 * It retrieves the current locale from the `next router` path locale options
 * and uses it to determine the direction of the layout and active language.
 */
export const useRTL = (): TUseRTLReturnType => {
  const locale = (useParams()?.locale || DEFAULT_LOCALE) as TLocale;
  const isRTL = isLangRTL(locale);
  const dir = isRTL ? 'rtl' : 'ltr';

  return {
    isRTL,
    dir,
    locale,
  };
};
